module.exports = __webpack_public_path__ + "static/img/wechat.de12bf4a.svg";